import { trackDeleteOffer } from './tracking';
import { TThunkAction } from '../../types/redux/thunk';
import { deleteOfferFailure, deleteOfferRequest, deleteOfferSuccess } from './deleteOfferActions';
import { fetchDeleteOfferFromComparison } from '../../repositories/offers-comparison/v1/delete-offer-from-comparison';
import { selectOfferGaLabel } from '../../selectors/offers';

interface IParams {
  offerId: number;
  first?: boolean;
}

export const deleteOffer =
  ({ offerId, first }: IParams): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { logger, httpApi }) => {
    const state = getState();
    const gaLabel = selectOfferGaLabel(offerId)(state);
    trackDeleteOffer(offerId, gaLabel);
    dispatch(deleteOfferRequest({ offerId }));

    try {
      await fetchDeleteOfferFromComparison({ httpApi, parameters: { offerId } });

      dispatch(deleteOfferSuccess({ offerId }));
    } catch (err) {
      if (first) {
        await dispatch(deleteOffer({ offerId }));
      } else {
        logger.error(err, {
          offerId,
          domain: 'src/shared/actions/compare#deleteOffer())',
        });

        dispatch(deleteOfferFailure({ offerId }));
      }
    }
  };
